<app-support-component [loggedInUser]="loggedInUser$ | async" [users]="users$ | async"></app-support-component>
